import { UserRole } from "../@types/userRole";

export const canViewControlPainel = (userType: UserRole) => {
  return userType !== "Consumer";
}